export class Modalidad {
    httpStatus:number;
    response: {
      id:string;
      codeResponse:string;
      response:string;
      list: [
        {
          id:string;
          name:string;
          description:string;
          price:string;
          order:string;
          currency: string;
          enabled: string;
        }
    ]
}
constructor(){
    this.httpStatus=0;
    this.response= {
      id:"",
      codeResponse:"",
      response:"",
      list: [
        {
          id:"",
          name:"",
          description:"",
          price:"",
          order:"",
          currency: "",
          enabled: ""
        }
    ]
}
}
}
